import { render } from "./DefaultImportScriptForm.vue?vue&type=template&id=aa6dd5e2&scoped=true"
import script from "./DefaultImportScriptForm.vue?vue&type=script&lang=js"
export * from "./DefaultImportScriptForm.vue?vue&type=script&lang=js"

import "./DefaultImportScriptForm.vue?vue&type=style&index=0&id=aa6dd5e2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa6dd5e2"]])

export default __exports__